const _ = require('lodash');

const filter = {
  service(items, filterText) {
    const lcFilterText = _.toLower(filterText);
    const $return = _.reduce(
      items,
      (final, service) => {
        if (
          _.toLower(service.name).includes(lcFilterText) ||
          _.toLower(service.comment).includes(lcFilterText) ||
          ('clients' in service &&
            service.clients.length > 0 &&
            'settings' in service.clients[0] &&
            'hosts' in service.clients[0].settings &&
            service.clients[0].settings.hosts.includes(lcFilterText))
        ) {
          final.push(service);
        } else if (service.clients.length > 0) {
          const orgUUIDs = _.map(service.clients, 'orgUUID');
          const siteUUIDs = _.flatMap(service.clients, 'siteUUID');
          // test all clients org uuid
          if (
            _.find(orgUUIDs, uuid => {
              return _.toLower(uuid).includes(lcFilterText);
            })
          ) {
            final.push(service);
          } else if (
            _.find(siteUUIDs, uuid => {
              return _.toLower(uuid).includes(lcFilterText);
            })
          ) {
            final.push(service);
          }
        }
        return final;
      },
      []
    );
    return $return;
  },
  acl(items, filterText) {
    return _.filter(items, item => {
      return item.name !== 'waf_allowlist' && _.toLower(item.name).includes(_.toLower(filterText));
    });
  },
  dictionary(items, filterText) {
    return _.filter(items, item => {
      return _.toLower(item.name).includes(_.toLower(filterText));
    });
  },
  aclEntries(items, filterText) {
    return _.filter(items, item => {
      const lcFilterText = _.toLower(filterText);
      return _.toLower(item.comment).includes(lcFilterText) || item.ip.includes(lcFilterText);
    });
  },
  dictionaryEntries(items, filterText) {
    return _.filter(items, item => {
      const lcFilterText = _.toLower(filterText);
      return (
        _.toLower(item.item_key).includes(lcFilterText) ||
        _.toLower(item.item_value).includes(lcFilterText)
      );
    });
  },
};

module.exports = filter;
